import { render, staticRenderFns } from "./addMaster.vue?vue&type=template&id=27c80d18"
import script from "./addMaster.vue?vue&type=script&lang=js"
export * from "./addMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports